export enum AxonRoutes {
  USER_MANAGEMENT = '/axon/admin/user-search',
  ORGANIZATION_MANAGEMENT = '/axon/admin/agency',
  CURRENT_USER_PROFILE = '/axon/profile/my',
}
